<template>
  <div
    class="router-header flex flex-wrap items-center"
    :disabled="button_loading"
    id="page-loading"
  >
    <div class="content-area__heading">
      <vs-button
        radius
        class="float-left mr-2"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click.stop="back()"
      ></vs-button>

      <span class="font"
        >{{ UserKycDetails.first_name }} {{ UserKycDetails.last_name }}</span
      >
    </div>
    <vx-card class="mt-4">
      <div class="p_details">
        <div class="vx-row p-4">
          <!--  Basic Details   -->
          <div class="w-full md:w-1/2">
            <div class="vx-col w-full">
              <h5 class="mb-4 border_bottom">
                {{ $t("labels.basic_details") }}
              </h5>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional">{{ $t("labels.name") }} :</span>
                </div>
                <div
                  class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8"
                  v-if="UserKycDetails"
                >
                  <span
                    v-if="UserKycDetails"
                    class="cursor-pointer"
                    @click="
                      viewParentsDetails(
                        UserKycDetails.user_id,
                        UserKycDetails.user_detail.role
                      )
                    "
                    >{{ UserKycDetails.first_name }}
                    {{ UserKycDetails.last_name }}</span
                  >

                  <!-- <p
                 class="cursor-pointer"
                  v-if="tr.user_detail"
                  @click.stop="viewParentsDetails(tr.user_id,tr.user_detail.role)"
                >{{tr.user_detail.name}}</p> -->
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.mobile") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8">
                  <p v-if="UserKycDetails" class="approved">
                    {{ UserKycDetails.mobile }}
                  </p>
                </div>
              </div>

              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.email") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8">
                  <p v-if="UserKycDetails.user_detail" class="approved">
                    {{ UserKycDetails.user_detail.email }}
                  </p>
                </div>
              </div>

              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional">{{ $t("labels.dob") }} :</span>
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8">
                  <p v-if="UserKycDetails" class="approved">
                    {{ UserKycDetails.dob | formatDate }}
                  </p>
                </div>
              </div>

              <div class="vx-row w-full pl-4 pt-4 parents_images">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.gender") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/2 xl:w-1/2">
                  <div
                    class="vx-row pt-3 pl-3"
                    v-if="UserKycDetails.gender == 'M'"
                  >
                    <div class="vx-coll w-full md:w-1/12 sm:w-1/12">
                      <img
                        src="@/assets/images/kids/boy.png"
                        class="kid_image"
                      />
                    </div>
                    <div class="vx-coll w-full md:w-1/3 sm:w-1/3">
                      <span class="text-right">{{ $t("labels.male") }}</span>
                    </div>
                  </div>
                  <div
                    class="vx-row pt-3 pl-3"
                    v-if="UserKycDetails.gender == 'F'"
                  >
                    <div class="vx-coll w-full md:w-1/12 sm:w-1/12">
                      <img
                        src="@/assets/images/kids/girl.png"
                        class="kid_image"
                      />
                    </div>
                    <div class="vx-coll w-full md:w-1/2 sm:w-1/2">
                      <span class="text-right">{{ $t("labels.female") }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.address") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/2 xl:w-1/2">
                  <p class="pt-3 text-left" v-if="UserKycDetails">
                    <span>
                      <feather-icon
                        icon="MapPinIcon"
                        class="inline-flex text-success"
                        svgClasses="w-4 h-4"
                      ></feather-icon>
                    </span>
                    {{ UserKycDetails.street_address1 }}
                    {{ UserKycDetails.city }} {{ UserKycDetails.zipcode }}
                  </p>
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.document_front") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8">
                  <a :href="UserKycDetails.document_front" target="_blank">
                    <div
                      class="ttable-img cursor-pointer"
                      v-if="UserKycDetails.document_front"
                    >
                      <!-- <img v-bind:src="UserKycDetails.document_front" /> -->
                      <vs-avatar
                        size="100px"
                        v-bind:src="UserKycDetails.document_front"
                      />
                    </div>
                  </a>
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.document_back") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8">
                  <a :href="UserKycDetails.document_back" target="_blank">
                    <div
                      class="ttable-img cursor-pointer"
                      v-if="UserKycDetails.document_front"
                    >
                      <!-- <img v-bind:src="UserKycDetails.document_back" /> -->
                      <vs-avatar
                        size="100px"
                        v-bind:src="UserKycDetails.document_back"
                      />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2">
            <div class="vx-col w-full">
              <h5 class="mb-4 border_bottom">
                {{ $t("labels.adis_details") }}
              </h5>

              <!-- <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/4 xl:w-1/4">
                  <span class="title_aditional">{{$t('labels.address')}} :</span>
                </div>
                <div
                  class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8"
                  v-if="UserKycDetails.iban_number"
                >
                  <span v-if="UserKycDetails.iban_number">{{UserKycDetails.iban_number}}</span>
                </div>
              </div> -->

              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.acc_number") }} :</span
                  >
                </div>
                <div
                  class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8"
                  v-if="UserKycDetails.account_number"
                >
                  <span v-if="UserKycDetails.account_number">{{
                    UserKycDetails.account_number
                  }}</span>
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.r_number") }} :</span
                  >
                </div>
                <div
                  class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8"
                  v-if="UserKycDetails.routing_number"
                >
                  <span v-if="UserKycDetails.routing_number">{{
                    UserKycDetails.routing_number
                  }}</span>
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.ssn_no") }} :</span
                  >
                </div>
                <div
                  class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8"
                  v-if="UserKycDetails.ssn"
                >
                  <span v-if="UserKycDetails.ssn">{{
                    UserKycDetails.ssn
                  }}</span>
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.kyc_status") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/8 xl:w-1/8">
                  <p v-if="UserKycDetails.kyc_status == 'A'" class="approved">
                    {{ $t("labels.approved") }}
                  </p>
                  <p v-if="UserKycDetails.kyc_status == 'P'" class="pending">
                    {{ $t("labels.pending") }}
                  </p>
                  <p v-if="UserKycDetails.kyc_status == 'R'" class="rejected">
                    {{ $t("labels.rejected") }}
                  </p>
                </div>
              </div>
              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.kyc_type") }} :</span
                  >
                </div>
                <!-- 'residence permit','identity card','licence','passport' -->
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/2 xl:w-1/2">
                  <p v-if="UserKycDetails.kyc_type">
                    {{ UserKycDetails.kyc_type | upper }}
                  </p>
                </div>
              </div>

              <div class="vx-row w-full pl-4 pt-4">
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/3">
                  <span class="title_aditional"
                    >{{ $t("labels.created_at") }} :</span
                  >
                </div>
                <div class="w-full sm:w-1/1 md:w-1/2 lg:w-1/2 xl:w-1/2">
                  <p v-if="UserKycDetails.created_at">
                    {{ UserKycDetails.created_at | formatDate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      UserKycDetails: [],
      page: null,
    };
  },
  mounted() {
    // let UserKycDetails =  this.$route.query.kyc;
    // console.log(this.$route.query.kyc);
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getUserDetails();
  },
  methods: {
    // viewParentsDetails(user_id) {
    //   console.log(user_id)
    //     this.$router.push("serviceprovider/views/" + user_id);
    // },

    viewParentsDetails(user_id, role) {
      console.log(role);
      if (role === "SP") {
        this.$router.push("/serviceprovider/views/" + user_id);
      } else {
        this.$router.push("/parents/views/" + user_id);
      }
    },

    loading() {
      this.loading(true, "#page-loading");
    },

    getUserDetails() {
      this.button_loader_success(true, "#page-loading");
      axios
        .get("KYC/getKYCStatus/" + this.$route.params.id)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          let data = response.data.data;
          this.UserKycDetails = data;
          console.log(this.UserKycDetails);
        })
        .catch((e) => {
          this.showError(e);
        });
    },

    back() {
      if (this.page) {
        this.$router.push({ name: "TeacherKyc", query: { page: this.page } });
        // this.$router.push({name: "Students",params:{page:this.page}});
      } else {
        history.back();
      }
    },
  },
};
</script>
